// ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Loading from "../animations/Loading";

const ProtectedRoute = ({ children, isLoggedIn, isLogginIn }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return <Loading />;
    }

    
    if (isLogginIn) {
        return isLoggedIn ? <Navigate to="/" /> : children; 
    } 

    return isLoggedIn ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;